import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectSecondaryLang } from '../actions';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const selectStyle = {
    marginTop: -15,
    marginRight: 20,
};

class SelectSecondaryLang extends Component {
    state = {
        value: localStorage.getItem('selectSecondaryLang') || this.props.secondaryLanguage || '',
    };

    componentDidMount() {
        this.props.selectSecondaryLang(this.state.value);
    }

    handleChange = (event, index, value) => {
        event.preventDefault();
        localStorage.setItem('selectSecondaryLang', value);
        this.setState({ value });
        this.props.selectSecondaryLang(value);
    };

    render() {
        const { LANGUAGES, supportedLanguages, defaultLanguage } = this.props;

        return (
            <SelectField
                floatingLabelText="Secondary Language"
                value={this.state.value}
                onChange={this.handleChange}
                style={selectStyle}
            >
                {supportedLanguages
                    .filter(lang => lang !== defaultLanguage)
                    .map(lang => <MenuItem key={lang} value={lang} primaryText={LANGUAGES[lang]} />)}
            </SelectField>
        );
    }
}

SelectSecondaryLang.propTypes = {
    // From connect
    LANGUAGES: PropTypes.object.isRequired,
    supportedLanguages: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    defaultLanguage: PropTypes.string.isRequired,
    secondaryLanguage: PropTypes.string.isRequired,
    selectSecondaryLang: PropTypes.func.isRequired,
};

export default connect(
    ({ commonI18Dashboard: { LANGUAGES, supportedLanguages, defaultLanguage, secondaryLanguage } }) => ({
        LANGUAGES,
        supportedLanguages,
        defaultLanguage,
        secondaryLanguage,
    }),
    { selectSecondaryLang },
)(SelectSecondaryLang);



/** WEBPACK FOOTER **
 ** ../src/dash/front/common-i18-dashboard-page/components/SelectSecondaryLang.js
 **/